import { GET_FLAGS } from '@/utils/store/actionTypes'
import { SET_FLAGS, SET_FLAGS_IS_FETCHED } from '@/utils/store/mutationTypes'
import cloneDeep from 'lodash/cloneDeep'

export default {
  async [GET_FLAGS] ({ commit }) {
    const response = await this.$axios.$get(`${process.env.API_URL}/v2/flags`, {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json',
        'OTA-External': 'true' // Bypass axios plugin Authorization Header override
      },
      withCredentials: false
    })

    const showfromDate = this.$moment('05-02-2025', 'DD-MM-YYYY')
    const showtoDate = this.$moment('27-02-2025', 'DD-MM-YYYY')
    const signupCampaignActive = this.$moment().isBetween(showfromDate, showtoDate)

    const signupCampaignActiveLastDay = this.$moment().isSame(cloneDeep(showtoDate).subtract(1, 'day'), 'day')

    const flags = {
      ...response,
      signup_campaign_active: signupCampaignActive || response.signup_campaign_active,
      signup_campaign_active_last_day: signupCampaignActiveLastDay || response.signup_campaign_active_last_day
    }

    commit(SET_FLAGS, { flags })
    commit(SET_FLAGS_IS_FETCHED, { isFetched: true })

    return response
  }
}
